import { getGlobals } from '../globals'
import { blacklistWebhooks } from './integrations'
import { prefixAjsLocalStorage } from '../analytics-storage'
import { increaseSequentialId } from './tracking-completion'
import perspectiveTracking from '../perspective-tracking'
import trackingOptions from './options'

// const isProduction = process.env.NODE_ENV === 'production'
const isProduction = true

export function track(name, trackingObj, optionsName) {
  /**
   *
   * @type {TrackingOptions}
   */
  const options = trackingOptions[optionsName]

  if (!isProduction) {
    console.log('track', !!window.analytics, name, trackingObj, options)
    return
  }

  const globals = getGlobals()

  if (isProduction) {
    if (options.tracking.perspective) {
      const adjustedTrackingObj = {
        ...globals,
        ...trackingObj,
      }
      if (options.sequential) {
        adjustedTrackingObj.sequentialId = increaseSequentialId()
      }

      perspectiveTracking.track(name, adjustedTrackingObj)
    }

    if (options.tracking.integrations && window.analytics) {
      window.analytics.track(
        name,
        {
          ...trackingObj,
          anonymousId: globals.anonymousId,
        },
        options.passThrough
      )
    }
  }
}

export function page(pageName, trackingObj) {
  if (!isProduction) {
    console.log('page', !!window.analytics, pageName, trackingObj)
    return
  }

  if (isProduction) {
    perspectiveTracking.page(pageName, trackingObj)

    if (window.analytics) {
      window.analytics.page(null, pageName, trackingObj, blacklistWebhooks)
    }
  }
}

export function identify(userInformation) {
  const globals = getGlobals()

  const id = userInformation.id

  if (!isProduction) {
    console.log('identify', !!window.analytics, userInformation)
  }

  if (window.analytics && isProduction) {
    window.analytics.identify(id, userInformation)
  }

  prefixAjsLocalStorage(globals.perspectiveCompanyId)
}
